import { render, staticRenderFns } from "./ModuleGlobalModals.vue?vue&type=template&id=edfc588e"
import script from "./ModuleGlobalModals.vue?vue&type=script&lang=js"
export * from "./ModuleGlobalModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports